/**
 * Where the equipment tree hangs off the Maintain section.
 *
 * One builder per level, so no surface hand-concatenates the shape: the grid's
 * card, the breadcrumb's switcher and the back button all have to produce the
 * same string by construction, and moving the root has to move all of them.
 */
export const MAINTAIN_ROOT = '/maintain';

export const EQUIPMENT_ROOT = `${MAINTAIN_ROOT}/equipment`;

/** Static segment under the equipment root — never a category id. */
export const EXTRACTED_SEGMENT = 'vessels-extracted';

export const EXTRACTED_EQUIPMENT_PATH = `${EQUIPMENT_ROOT}/${EXTRACTED_SEGMENT}`;

/** One category's items. */
export const equipmentCategoryPath = (categoryId: string): string =>
  `${EQUIPMENT_ROOT}/${categoryId}`;

/** One item's page, under its category. */
export const equipmentItemPath = (categoryId: string, itemId: string): string =>
  `${equipmentCategoryPath(categoryId)}/${itemId}`;

export const equipmentEditPath = (categoryId: string, itemId: string): string =>
  `${equipmentItemPath(categoryId, itemId)}/edit`;
